<template>
  <div>
    <title-bar title="电价维护">
      <el-button type="primary" icon="fa fa-save" :loading="loading" @click="save">保存</el-button>
    </title-bar>
    <div class="page-body">
      <el-form inline>
        <el-form-item label="年份">
          <el-date-picker v-model="queryForm.y" type="year" value-format="yyyy" @change="query"></el-date-picker>
        </el-form-item>
        <span class="color-error" style="margin-left: 10px">电价单位：元</span>
      </el-form>

      <el-table stripe :data="records" :border="true" v-loading="loading">
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="compName" label="单位名称" min-width="200"></el-table-column>
        <el-table-column prop="m1" label="1月" align="center" min-width="90">
          <template slot-scope="{row, $index}">
            <el-input-number v-model="row.m1"  :controls="false" style="width:100%;text-align:center"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="m2" label="2月" align="center" min-width="90">
          <template slot-scope="{row, $index}">
            <el-input-number v-model="row.m2"  :controls="false" style="width:100%;text-align:center"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="m3" label="3月" align="center" min-width="90">
          <template slot-scope="{row, $index}">
            <el-input-number v-model="row.m3"  :controls="false" style="width:100%;text-align:center"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="m4" label="4月" align="center" min-width="90">
          <template slot-scope="{row, $index}">
            <el-input-number v-model="row.m4"  :controls="false" style="width:100%;text-align:center"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="m5" label="5月" align="center" min-width="90">
          <template slot-scope="{row, $index}">
            <el-input-number v-model="row.m5"  :controls="false" style="width:100%;text-align:center"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="m6" label="6月" align="center" min-width="90">
          <template slot-scope="{row, $index}">
            <el-input-number v-model="row.m6"  :controls="false" style="width:100%;text-align:center"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="m7" label="7月" align="center" min-width="90">
          <template slot-scope="{row, $index}">
            <el-input-number v-model="row.m7"  :controls="false" style="width:100%;text-align:center"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="m8" label="8月" align="center" min-width="90">
          <template slot-scope="{row, $index}">
            <el-input-number v-model="row.m8"  :controls="false" style="width:100%;text-align:center"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="m9" label="9月" align="center" min-width="90">
          <template slot-scope="{row, $index}">
            <el-input-number v-model="row.m9"  :controls="false" style="width:100%;text-align:center"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="m10" label="10月" align="center" min-width="90">
          <template slot-scope="{row, $index}">
            <el-input-number v-model="row.m10"  :controls="false" style="width:100%;text-align:center"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="m11" label="11月" align="center" min-width="90">
          <template slot-scope="{row, $index}">
            <el-input-number v-model="row.m11"  :controls="false" style="width:100%;text-align:center"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="m12" label="12月" align="center" min-width="90">
          <template slot-scope="{row, $index}">
            <el-input-number v-model="row.m12"  :controls="false" style="width:100%;text-align:center"></el-input-number>
          </template>
        </el-table-column>
      </el-table>
    </div>


  </div>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
import CodeSelect from "@/components/base/CodeSelect";
export default {
  name: 'KwhPriceSetting',
  components: {CodeSelect, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      editing: false,
      queryForm: {
        y: new Date().getFullYear()+""
      },
      records: []
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    query(){
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.postForm("/company-kwh-price/price-list", this.queryForm, true).then(dr => {
        this.records = dr.rows;
      }).finally(()=>{
        this.loading = false;
      })
    },
    save(){
      let data = [];
      this.records.forEach(r=>{
        for(let i=1;i<=12;i++) {
          if(r["m"+i]) {
            data.push({
              compId: r.compId,
              y: this.queryForm.y,
              m: i,
              price: r["m"+i]
            })
          }
        }
      });
      this.loading = true;
      this.postJson("/company-kwh-price/save?y="+this.queryForm.y, data, true).then(dr => {
      }).finally(()=>{
        this.loading = false;
      })
    }
  }
}
</script>

<style scoped>

</style>